<form [formGroup]="form">
  <div class="row">
    <div [ngClass]="bookingEditor.editorType === 'smallEditor' ? 'col-12' : 'col-6'">
      <div [ngClass]="{'mb-3' : bookingEditor.editorType === 'smallEditor'}" class="form-group validateMe">
        <label class="form-label" for="Title">{{'lang.globals.title' | translate}}<span class="red">*</span></label>
        <div class="input-group">
          <input class="form-control" formControlName="Title" id="Title" sbAutofocus type="text">
          <a (click)="showColorPickerFn()" class="input-group-append cursor-pointer">
              <span class="input-group-text h-100">
                          <sb-icon icon="photo"></sb-icon>
              </span>
          </a>
        </div>
        <div #colorPickerElement
             (colorPickerCancel)="cancel()"
             (colorPickerSelect)="setColor($event)"
             (cpPresetColorsChange)="colorService.setColor($event)"
             [(colorPicker)]="color"
             [(cpToggle)]="showColorPicker"
             [cpAddColorButtonText]="'lang.globals.addColorLabel' | translate"
             [cpAddColorButton]="checkColorSavePermission()"
             [cpAlphaChannel]="'disabled'"
             [cpCancelButtonClass]="'btn btn-danger'"
             [cpCancelButtonText]="'lang.globals.cancel' | translate"
             [cpCancelButton]="true"
             [cpCloseClickOutside]="false"
             [cpOKButtonClass]="'btn btn-primary'"
             [cpOKButtonText]="'lang.globals.addColor' | translate"
             [cpOKButton]="true"
             [cpOutputFormat]="'hex'"
             [cpMaxPresetColorsLength]="null"
             [cpPresetColors]="colorService.colorDef"
             [cpPresetEmptyMessage]="'lang.globals.noColorsAdded' | translate"
             [cpPresetLabel]="'lang.globals.presetColors' | translate"
             [cpRemoveColorButtonClass]="'d-none'"
             [cpSaveClickOutside]="false"
             [cpUseRootViewContainer]="false"
             [cpWidth]="'255px'" style="z-index: 999;">
        </div>
      </div>
    </div>
    <div *ngIf="orderingAvailable" class="col-4">
      <div [ngClass]="{'mb-3' : bookingEditor.editorType === 'smallEditor'}" class="form-group validateMe">
        <label class="form-label" for="Sequence">{{'lang.globals.sequence' | translate}}</label>
        <input class="form-control" formControlName="Sequence" id="Sequence" type="number">
      </div>
    </div>
    <div [ngClass]="bookingEditor.editorType === 'smallEditor' ? 'col-12' : 'col-6'">
      <div *ngIf="bookingEditor.editorType === 'bigEditor'" class="form-group validateMe">
        <label class="form-label" for="Duration">{{'lang.globals.duration' | translate}}<span class="red">*</span></label>
        <input class="form-control" formControlName="Duration" id="Duration" type="text">
      </div>
    </div>
    <div [ngClass]="bookingEditor.editorType === 'smallEditor' ? 'col-6' : 'col-6'">
      <div [ngClass]="{'mb-3' : bookingEditor.editorType === 'smallEditor'}" class="form-group">
        <sb-local-date-time-input [disablePicker]="form.get('From').disabled" [kind]="'RANGE_START'" [minDate]="now"
                                  [seconds]="false" [title]="translate.instant('lang.globals.startTime')"
                                  [weekNumbers]="true" [inputRequired]="true"
                                  formControlName="From"
                                  id="From"></sb-local-date-time-input>
        <div *ngIf="From.dirty && From.errors?.required" class="alert alert-danger">
          {{'lang.commercialEdit.startTimeWarning' | translate}}</div>
        <div *ngIf="form.dirty && form.errors?.endDateAfterStartDate" class="alert alert-danger">
          {{'lang.commercialEdit.startTimeCorrection' | translate}}</div>
      </div>
    </div>
    <div [ngClass]="bookingEditor.editorType === 'smallEditor' ? 'col-6' : 'col-6'">
      <div class="form-group mb-0">
        <sb-local-date-time-input [disablePicker]="form.get('Till').disabled" [kind]="'RANGE_END'"
                                  [minDate]="now > From.value ? now : From.value"
                                  [seconds]="false" [title]="translate.instant('lang.globals.dueTime')"
                                  [weekNumbers]="true" [inputRequired]="true"
                                  formControlName="Till"
                                  id="Till"></sb-local-date-time-input>
        <div *ngIf="Till.dirty && Till.errors?.required" class="alert alert-danger">
          {{'lang.commercialEdit.dueTimeWarning' | translate}}</div>
        <div *ngIf="form.dirty && form.errors?.endDateAfterStartDate" class="alert alert-danger">
          {{'lang.commercialEdit.dueTimeCorrection' | translate}}</div>
      </div>
    </div>
  </div>
</form>
